import { render } from "./AdminReplies.vue?vue&type=template&id=ab997f38&scoped=true"
import script from "./AdminReplies.vue?vue&type=script&lang=js"
export * from "./AdminReplies.vue?vue&type=script&lang=js"

import "./AdminReplies.vue?vue&type=style&index=0&id=ab997f38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab997f38"]])

export default __exports__